<!--
 * @Author: Admni
 * @Description: 
 * @Date: 2021-01-13 20:05:32
 * @LastEditTime: 2021-03-03 10:58:17
-->
<template>
  <div>
    <div style="margin-bottom:10px;">
      <el-tag
        :key="index"
        v-for="(tag, index) in curTagsList"
        closable
        effect="plain"
        :disable-transitions="false"
        @close="tagDel(index, tag.pk)"
      >
        {{ tag.name }}
      </el-tag>
    </div>

    <div>
      <el-button class="button-new-tag" size="small" @click="tagVisible = true"
        >新增 +</el-button
      >
    </div>

    <el-dialog title="标签列表" :visible.sync="tagVisible" width="30%">
      <div>
        <el-tag
          :key="index"
          v-for="(tag, index) in tgList"
          :effect="tag.flag ? 'dark' : 'plain'"
          :disable-transitions="false"
          @click="changeTag(index, tag.pk)"
        >
          {{ tag.name }}
        </el-tag>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="tagVisible = false">取 消</el-button>
        <el-button type="primary" @click="tagSure">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { tagsList, updateTag } from "../../api/chat";
export default {
  props: ["tagVisib", "curId", "curPkg", "curTagsList"],
  data() {
    return {
      dynamicTags: ["标签一", "标签二", "标签三"],
      inputVisible: false,
      inputValue: "",
      tgList: [],
      sendList: [],
      tagVisible: false,
    };
  },
  mounted() {
    let tgList = JSON.parse(localStorage.getItem("tag")).tags;
    tgList.forEach((item) => {
      item.flag = false;
    });

    tgList.forEach((t, tInd) => {
      this.curTagsList.forEach((c, cInd) => {
        if (t.pk === c.pk) {
          t.flag = true;
        }
      });
    });
    this.tgList = tgList;
  },
  methods: {
    changeTag(ind, val) {
      this.tgList[ind].flag = !this.tgList[ind].flag;
    },
    isChange(val, ind) {
      this.curTagsList.map((item) => {
        let flag = false;
        if (item.pk === val) {
          flag = true;
        }
        if (flag) {
          return "dark";
        } else {
          return "plain";
        }
      });
      // return 'dark'
    },
    tagSure() {
      let tags = [];
      this.tgList.forEach((item) => {
        if (item.flag) {
          tags.push(item.pk);
        }
      });
      let params = {
        tags,
        i: this.curId,
        p: this.curPkg,
      };
      updateTag(params)
        .then((res) => {
          this.$parent.getUserInfo();
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.tagVisible = false;
        })
        .catch((err) => {
          this.$message.error("发生错误，请重试");
        });
    },
    tagDel(index, val) {
      let tags = [];
      this.curTagsList.forEach((item) => {
        if (item.pk !== val) {
          tags.push(item.pk);
        }
      });
      let params = {
        tags,
        i: this.curId,
        p: this.curPkg,
      };
      updateTag(params)
        .then((res) => {
          this.$parent.getUserInfo();
          this.$message({
            message: "删除成功",
            type: "success",
          });
          this.tagVisible = false;

          this.tgList.forEach((t) => {
            if (t.pk === val) {
              t.flag = false;
            }
          });
        })
        .catch((err) => {
          this.$message.error("发生错误，请重试");
        });
    },
  },
};
</script>

<style scoped>
.el-tag + .el-tag {
  margin-left: 10px;
  /* margin-bottom: 10px; */
}
.button-new-tag {
  /* margin-left: 10px; */
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  margin-bottom: 10px;
  vertical-align: bottom;
}
</style>
